import * as yup from "yup";

export const providerContactSchema = yup.object().shape({
  provider_contact_name: yup.string(),
  provider_contact_email: yup.string().email("Invalid email format"),
  provider_contact_phone: yup
    .string()
    .matches(/^[0-9]+$/, "Phone number must contain only numbers"),
});
